import { useQuery } from '@tanstack/react-query';
import { fetchCandidateDashboardSummary, type CandidateDashboardSummary } from '../api/candidateDashboard';

export function useCandidateDashboardSummary() {
  return useQuery<CandidateDashboardSummary, Error>({
    queryKey: ['candidate-dashboard-summary'],
    queryFn: fetchCandidateDashboardSummary,
    staleTime: 1000 * 60,
    retry: 2,
    retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 8000),
  });
}
